import { PRODUCTS_TAB } from "../../framework/tab/tabUtilsConstants";
import {
  medicineCategories,
  medicineScheduleTypes,
} from "../../utils/constant";

export const columnDefs = [
  {
    headerName: "Product",
    field: "medicineNameDetailed",
    width: 380,
  },
  {
    headerName: "Short Code",
    field: "medicineShortCode",
    width: 100,
  },
  {
    headerName: "Packaging",
    field: "medicinePackaging",
    width: 120,
  },
  {
    headerName: "Item Type",
    field: "itemtype",
    width: 120,
  },
  {
    headerName: "Scheduled Type",
    field: "scheduledId",
    width: 130,
  },
  {
    headerName: "Manufacturer",
    field: "manufacturerName",
    width: 300,
  },
  {
    headerName: "Category",
    field: "categoryId",
    width: 100,
  },
];

export const columnDefsFunctions = {
  scheduledId: {
    valueGetter: (params) => {
      return medicineScheduleTypes.filter(
        (scheduleType) => scheduleType.id === params.data.scheduledId
      )[0]?.label;
    },
  },
  categoryId: {
    valueGetter: (params) => {
      return medicineCategories.filter(
        (g) => g.id === params.data.categoryId
      )[0]?.label;
    },
  },
};

export const initial_state_products = {
  type: PRODUCTS_TAB,
  label: "Products",
  allowMultipleTabs: false,
};
